module.exports = __webpack_public_path__ + "img/pin-duplo-diamante.6989be0c.png";